<template>
  <popup-headline
    :title="translations.title"
    @toggle-popup="togglePopup"
  />
  <div
    v-show="state.isPopupOpened"
    class="u-mt--s"
  >
    <div
      class="c-hands-free-content u-font-size-large"
      v-html="translations.content"
    />
    <div
      class="c-hands-free-vote u-flex u-font-size-large u-mb--s u-mt--s"
    >
      <button
        v-if="!voted"
        class="c-button"
        @click="votedUp"
      >
        <Icon
          class="u-mr--xs"
          :icon="iconThumbsUp"
          :size="16"
        />
        {{ translations.voteUp }}
      </button>
      <button
        v-if="!voted"
        class="c-button"
        @click="votedDown"
      >
        <Icon
          class="u-mr--xs"
          :icon="iconThumbsDown"
          :size="16"
        />
        {{ translations.voteDown }}
      </button>
      <div
        v-show="voted"
        class="c-recipe-question__success-message u-flex u-flex-align-center u-width-text"
      >
        <Icon
          :icon="iconCheckmark"
          :size="16"
          class="u-mr--xs"
        />
        {{ translations.successMessage }}
      </div>
    </div>
    <button
      class="c-button c-button--solid u-font-size-large"
      @click="closeHandsFreeFlow"
    >
      {{ translations.buttonText }}
    </button>
  </div>
</template>

<script>

import { ref } from 'vue'
import { state } from '@/composition/voiceState'
import PopupHeadline from '@/components/recipe/handFreeCookingStages/PopupHeadline.vue'
import Icon from '@/components/Icon.vue'
import iconThumbsUp from '@/assets/img/icons/thumbs-up.svg'
import iconThumbsDown from '@/assets/img/icons/thumbs-down.svg'
import iconCheckmark from '@/assets/img/icons/checkmark--outline.svg'
import tracking from '@/utils/gtm-util'

export default {
  components: {
    Icon,
    PopupHeadline
  },
  props: {
    translations: {
      type: Object,
      required: true
    }
  },
  emits: ['closeHandsFreeFlow', 'togglePopup'],
  setup(_, { emit }) {
    const closeHandsFreeFlow = () => {
      emit('closeHandsFreeFlow')
      tracking.handsfreeOffboardingOption('close widget', null)
    }

    const togglePopup = () => {
      emit('togglePopup')
    }

    const voted = ref(false)

    const votedUp = () => {
      voted.value = true
      tracking.handsfreeOffboardingOption('like', _.translations.voteUp)
    }

    const votedDown = () => {
      voted.value = true
      tracking.handsfreeOffboardingOption('dislike', _.translations.voteDown)
    }

    return {
      closeHandsFreeFlow,
      votedUp,
      votedDown,
      togglePopup,
      voted,
      state,
      iconThumbsUp,
      iconThumbsDown,
      iconCheckmark
    }
  }
}
</script>
